enum QUESTION_OPTIONS_LAYOUT {
  STACKED = 'STACKED',
  FLEX = 'FLEX',
}

export default QUESTION_OPTIONS_LAYOUT;
